import {useEffect} from "react";
import {useFetchImpactAreas} from "../../hooks/useFetchImpactAreas";
import {updateInfluenceZoneData} from "./data";

export const ImpactAreasProvider: React.FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const {impactAreas, error} = useFetchImpactAreas();

  useEffect(() => {
    updateInfluenceZoneData(impactAreas);
  }, [impactAreas]);

  if (error) {
    console.error("Ошибка загрузки impact areas:", error);
  }

  return <>{children}</>;
};
